import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter, RouteComponentProps } from 'react-router-dom';
import CryptoJS from 'crypto-js'
import Organization from '../../../../types/Organization'
import Provider from '../../../../types/Provider'
import RootState from '../../../../types/RootState'
import User from '../../../../types/User'
import Select from 'react-select'
import { Button, Form, Nav, Tab } from 'react-bootstrap'
import { renderToStaticMarkup } from 'react-dom/server'
import { divIcon } from 'leaflet'
import FacilityRow from '../FacilityRow'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { OpenStreetMapProvider } from 'leaflet-geosearch'
import { addUserActivity } from '../../../../redux/actions/authentication'
import 'leaflet/dist/leaflet.css'
import './index.css'
import request from 'superagent'
import { getDomainName } from '../../../../utils/envVariables'

interface Props extends RouteComponentProps {
  height: number;
  activeKey: string;
  selectedOrganization: Organization;
  sortFacilities: string;
  user: User;
  facilities: Array<Provider>;
  addUserActivity: (data: { eid: string; memberId?: number; organizationId?: number }, token: string) => void;
  onChangeSort: (selected: any) => void;
  onSelectFacility: (event: any, provider: Provider) => void;
  getLocationApplications?: (organizationId: number, token: string) => void;
}

interface State {
  key: string;
  lat: number;
  lng: number;
  zoom: number;
  map?: Map;
  openApplyNewLocation: boolean;
  addingLocationApplication: boolean;
}



class FacilitiesList extends Component<Props> {
  state = {
    key: 'facility-list',
    lat: 43.7730,
    lng: -88.4471,
    zoom: 10,
    gisProvider: new OpenStreetMapProvider(),
    openApplyNewLocation: false,
    user: null,
    organizationId: null,
    addingLocationApplication: false,
  }

  componentDidMount() {
    this.props.facilities.forEach((facility, index) => {
      if (facility.address_1 !== undefined && facility.city !== undefined && facility.county !== undefined && facility.state !== undefined && facility.zip_code !== undefined)
        this.getCoords(this.state.gisProvider, facility.address_1, facility.city, facility.county, facility.state, facility.zip_code, index)
    })
  }

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.facilities !== prevProps.facilities) {
      this.props.facilities.forEach((facility, index) => {
        if (facility.address_1 !== undefined && facility.city !== undefined && facility.county !== undefined && facility.state !== undefined && facility.zip_code !== undefined)
          this.getCoords(this.state.gisProvider, facility.address_1, facility.city, facility.county, facility.state, facility.zip_code, index)
      })
    }
  }

  handleSubmitApplicationType = (values: any) => {
    const { selectedOrganization, user } = this.props;
    const token = localStorage.getItem('token');

    request
      .post(`${getDomainName()}/api/locationApplication/${selectedOrganization.organization_id}/${user.user_id}`)
      .set('Accept', 'application/json')
      .set('access-token', token)
      .then((response) => {
        const { values } = response.body
        // if (!signed) {
        //   setAgreementError(true)
        // } else {
        const dataBody = {
          values
          // }
          // dispatch(updateProviderApplicationItem(token, providerApplication.providerApplicationId, dataBody))
          // setSubmittingAgreement(true)
        }
      }
        // })
        // .catch(() => {
        //   setAgreementError(true)
        // })
        // // this.props.dispatch(
        // addLocationApplication(values, selectedOrganization.organization_id, user.user_id, token)


        // this.setState({
        //   addingLocationApplication: true,
        //   openApplyNewLocation: false,
        // });
      )
  };

  handleChangeTab = (key: string) => {
    const { selectedOrganization, user, addUserActivity } = this.props
    const emailKey = 'lakelandproviderportalinsertuserencryption'
    const email = user.isLakeland ? { eid: CryptoJS.AES.encrypt(user.email, emailKey).toString() } : JSON.parse(localStorage.getItem('p_sid') || '{}')
    const token = localStorage.getItem('token') !== null && localStorage.getItem('token') !== 'undefined' ? JSON.parse(localStorage.getItem('token') || '') : ''

    const userActivity = {
      eid: email.eid,
      activity: key === 'application-list' ? 'View Applications' : `View Facilities${key === 'facility-map' ? ' Map' : ''}`,
      organizationId: selectedOrganization.organization_id
    }
    addUserActivity(userActivity, token)

    this.setState({ key })

    if (key === 'facility-map') {
      setTimeout(() => {
        (this.refs.map as Map).leafletElement.invalidateSize(false)
      }, 175) // Adjust timeout to tab transition
    }
  }


  handleOpenModal = () => {
    this.setState({ openApplyNewLocation: true }); // Open modal
  }

  handleCloseModal = () => {
    this.setState({ openApplyNewLocation: false }); // Close modal
  }

  getCoords = async (provider: any, address: string, city: string, county: string, state: string, zip_code: string, index: number) => {
    try {
      const results = await provider.search({ query: address + ', ' + city + ', ' + county + ', ' + state + ', ' + zip_code })
      this.setState({ ['marker_' + index]: results[0] })
    } catch (e) { }
    //console.log("For row " + index + " we got: " + this.state['marker_' + index])
    //console.log("With inputs: " + address + ', ' + city + ', ' + county + ', ' + state + ', ' + zip_code);
  }

  getPopupContent = (index) => {
    if (this.props.facilities !== undefined) {
      if (this.props.facilities.length !== 0) {
        return <div style={{ width: 315 }} onClick={(event: any) => { this.props.onSelectFacility(event, this.props.facilities[index]) }}>
          <p style={{ fontSize: 12, color: '#3e9abd', textDecoration: 'underline' }}>{this.props.facilities[index].provider_name}</p>
          Type: <b>Facility</b>
          &nbsp;|&nbsp;
          Tax ID: <b>{this.props.facilities[index].tax_id_number}</b>
          <br />
          <br />
          Status:
          {
            this.props.facilities[index].status === 'Active'
              ? (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'green', color: 'white', width: 100, textAlign: 'center' }}>ACTIVE</span>)
              : (<span style={{ display: 'inline-block', marginLeft: 5, backgroundColor: 'red', color: 'white', width: 100, textAlign: 'center' }}>INACTIVE</span>)
          }
          <br />
          <br />
          Address: <b>{this.props.facilities[index].address_1}</b>
          <br />
          City: <b>{this.props.facilities[index].city}</b>
          <br />
          County: <b>{this.props.facilities[index].county}</b>
          <br />
          State: <b>{this.props.facilities[index].state}</b>
          <br />
          Zip: <b>{this.props.facilities[index].zip_code}</b>
          <br />
          <br />
          <span className="facilityRowEditButton">View Facility Profile</span>
          <FontAwesomeIcon
            icon={['fas', 'chevron-circle-right']}
            size="lg"
            className="facilityRowEditIcon"
          />
        </div>
      }
    }
  }

  getMarkersFromState() {
    var i

    var markers = [{ x: 0, y: 0 }]

    for (i = 0; i < this.props.facilities.length; i++) {
      markers[i] = this.state['marker_' + i]
    }

    return markers
  }

  render() {
    const { key, zoom, openApplyNewLocation } = this.state
    const position = [this.state.lat, this.state.lng]
    const { height, sortFacilities, facilities, onChangeSort, onSelectFacility, } = this.props
    const sortOptions = [
      { value: 'a-z', label: 'Sort by A - Z' },
      { value: 'z-a', label: 'Sort by Z - A' }
    ]
    const iconMarkup = renderToStaticMarkup(
      <FontAwesomeIcon icon={['fas', 'map-marker-alt']} size='2x' color='#3e9abd' />
    )
    const customMarkerIcon = divIcon({
      html: iconMarkup,
      className: 'no-shadow' // dummy class to get rid of default box shadow on marker element
    })

    var markers = [{ x: 0, y: 0 }]

    var tempMarkers = this.getMarkersFromState()

    var i

    for (i = 0; i < 5; i++) {
      if (tempMarkers !== undefined && tempMarkers[i] !== undefined)
        if (tempMarkers[i].y !== undefined)
          markers[i] = tempMarkers[i]
        else
          markers[i] = { x: 0, y: 0 }
      else
        markers[i] = { x: 0, y: 0 }
    }


    return (
      <div className="facilities-container">

        <Tab.Container activeKey={key} onSelect={(key: any) => this.handleChangeTab(key)}>
          <div className="facilities-filter-and-sort">
            <Nav variant="pills" className="facilities-view">
              <Nav.Item className='facilities-nav-item-pills'>
                <Nav.Link eventKey="facility-list">Facility List</Nav.Link>
              </Nav.Item>
              <Nav.Item className='facilities-nav-item-pills'>
                <Nav.Link eventKey="facility-map">Map</Nav.Link>
              </Nav.Item>
              {/* <Nav.Item className='facilities-nav-item-pills'>
                <Nav.Link eventKey="application-list">Applications</Nav.Link>
              </Nav.Item> */}
            </Nav>
            {key === 'facility-list' && (
              <Form.Group controlId="memberForm.sortSelect" className="facilities-sort">

                <Select
                  placeholder="Choose an option"
                  options={sortOptions}
                  value={sortOptions.find((sortType: any) => sortType.value === sortFacilities)}
                  onChange={onChangeSort}
                />
              </Form.Group>
            )}

          </div>
          <Tab.Content>
            <Tab.Pane eventKey="facility-list">
              <div>
                {
                  facilities
                    .sort((a, b) => {
                      return (a.provider_name < b.provider_name ? -1 : 1) * (sortFacilities === 'a-z' ? 1 : -1)
                    })
                    .map((facility, index) =>
                      <FacilityRow
                        key={index}
                        provider={[facility]}
                        onSelectFacility={(event: any, provider: Provider) => { onSelectFacility(event, provider) }}
                      />
                    )
                }
              </div>
            </Tab.Pane>
            <Tab.Pane eventKey="facility-map">
              <div style={{ height: height, width: '100%' }}>
                <Map ref='map' center={position} zoom={zoom} style={{ width: '100%', height: height - 330 }}>
                  <TileLayer
                    attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                    url='https://{s}.tile.osm.org/{z}/{x}/{y}.png'
                  />
                  {
                    markers.map((marker, index) => {
                      if (marker.y !== 0 && marker.x !== 0) {
                        return <Marker key={index} position={[marker.y, marker.x]} icon={customMarkerIcon}>
                          <Popup>
                            {this.getPopupContent(index)}
                          </Popup>
                        </Marker>
                      }
                      else
                        return null
                    })
                  }
                </Map>
              </div>
            </Tab.Pane>

          </Tab.Content>
        </Tab.Container>
      </div>
    )
  }
}

const mapStateToProps = (state: RootState) => ({
  selectedOrganization: state.authentication.selectedOrganization,
  applications: state.locationApplication.locationApplications.data,
  user: state.authentication.user.data,
})

const mapDispatchToProps = (dispatch: any) => ({
  addUserActivity: (data: { eid: string; activity: string; memberId?: number; organizationId?: number; providerId?: number }, token: string) => dispatch(addUserActivity(data, token))
})

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(FacilitiesList));